package techla.base

actual fun techla_log(message: String) {
    console.log(message)
}
